var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "90%",
      "scrollable": true,
      "name": "visit-log",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "opened": _vm.onOpen,
      "closed": _vm.onHidden
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": 'client-visit-log-' + _vm.visitId + '-dialog'
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Historie úprav návštěvy\n    ")]), _vm._v(" "), (_vm.logVisit.length > 0 && _vm.logVisitPending !== true) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("verze")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("akce")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("změna")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("provedl")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("datum a čas")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logVisit), function(log) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(log.version))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.action))]), _vm._v(" "), _c('td', [_vm._l((log.data), function(value, key) {
      return [_c('span', [_c('i', [_vm._v(_vm._s(key))]), _vm._v(": "), _c('b', [_vm._v(_vm._s(value))])]), _c('br')]
    })], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.logged_at))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.logVisit.length < 1 && _vm.logVisitPending !== true) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n        návštěva bez historie\n    ")]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec85990a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/modals/VisitLog.vue
// module id = 628
// module chunks = 0